import React, { ReactNode, useEffect, useState } from 'react';
import Preloader from '@components-shared/preloader';
import { getCulture, getPresetLocale, i18nextInitialize } from '@locales/helpers';

export const I18nextProvider = ({ children }: { children: ReactNode }) => {
  const [isI18nextReady, setIsI18nextReady] = useState<boolean>(false);

  useEffect(() => {
    const i18nextInit = async () => {
      const defaultLanguage = getPresetLocale() ?? getCulture();

      await i18nextInitialize(defaultLanguage);
      setIsI18nextReady(true);
    };

    void i18nextInit();
  }, []);

  return isI18nextReady ? <>{children}</> : <Preloader />;
};
